// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var $$Date = require("../../common/types/Date.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var $$Promise = require("reason-promise/src/js/promise.bs.js");
var UTCDate = require("../../common/types/UTCDate.bs.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Property = require("../../clients/types/Property.bs.js");
var DateFns = require("date-fns");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var ViewStack = require("../../common/ViewStack.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var FeaturesV3 = require("../../featureFlipper/FeaturesV3.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CurrentUser = require("../../common/CurrentUser/CurrentUser.bs.js");
var ReactRender = require("../../utils/ReactRender.bs.js");
var Types__User = require("../../user/Types__User.bs.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var Avatar__Jsx3 = require("../../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
var Dialog__Jsx3 = require("../../../uikit/reason/molecules/Dialog/Dialog__Jsx3.bs.js");
var NonEmptyList = require("../../common/types/NonEmptyList.bs.js");
var Theme__Color = require("../../common/Theme/Theme__Color.bs.js");
var Buttons__Jsx3 = require("../../../uikit/reason/atoms/Buttons/Buttons__Jsx3.bs.js");
var SystemMessages = require("../../systemMessages/SystemMessages.bs.js");
var Touchable__Jsx3 = require("../../../uikit/reason/atoms/Touchable/Touchable__Jsx3.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Colors = require("uikit/styles/colors");
var Conversations__Types = require("../types/Conversations__Types.bs.js");
var Utils__AttachmentUrl = require("../../../utils/Utils__AttachmentUrl.bs.js");
var WarningSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/WarningSection__Jsx3.bs.js");
var ConversationCard__Jsx3 = require("../../../uikit/reason/molecules/ConversationCard/ConversationCard__Jsx3.bs.js");
var Conversations__GraphQL = require("../graphql/Conversations__GraphQL.bs.js");
var HighlightSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/HighlightSection__Jsx3.bs.js");
var TMPUIKIT___Price__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT____Price/TMPUIKIT___Price__Jsx3.bs.js");

function getPeople(currentUserId, participants) {
  return Belt_List.toArray(Belt_List.map(Belt_List.length(participants) > 1 ? Belt_List.keep(participants, (function (x) {
                          if (x) {
                            return x._0.id !== currentUserId;
                          } else {
                            return true;
                          }
                        })) : participants, (function (x) {
                    if (!x) {
                      return {
                              shortLabel: "Agent chose to hide their name",
                              longLabel: "Agent chose to hide their name",
                              avatarURL: AvatarSrcUrl.place_holder
                            };
                    }
                    var user = x._0;
                    var match = user.membershipStatus;
                    return {
                            shortLabel: Belt_Option.getWithDefault(Belt_Array.get(Types__User.shortLabel(user).split(" "), 0), "Agent"),
                            longLabel: Types__User.label(user),
                            avatarURL: match === "TERMINATED" ? AvatarSrcUrl.place_holder : Types__User.avatarURL(undefined, undefined, user)
                          };
                  })));
}

function Conversations__Components$ParticipantsBanner(props) {
  var people = getPeople(props.currentUser.id, props.conversation.participants);
  if (people.length === 0) {
    return null;
  }
  var tmp;
  if (people.length !== 1) {
    tmp = React.createElement(Avatar__Jsx3.Group.make, {
          children: Belt_Array.map(Belt_Array.slice(people, 0, 2), (function (param) {
                  var avatarURL = param.avatarURL;
                  var longLabel = param.longLabel;
                  return JsxPPXReactSupport.createElementWithKey(avatarURL + longLabel, Avatar__Jsx3.make, {
                              src: avatarURL,
                              name: longLabel
                            });
                })),
          size: "tiny"
        });
  } else {
    var match = people[0];
    tmp = React.createElement(Avatar__Jsx3.make, {
          src: match.avatarURL,
          name: match.longLabel,
          size: "tiny"
        });
  }
  return React.createElement(ViewStack.make, {
              pb: {
                NAME: "px",
                VAL: 20
              },
              space: "sm",
              alignItems: "center",
              flexDirection: "row",
              flexGrow: 0,
              position: "relative",
              children: Caml_option.some(null)
            }, tmp, React.createElement(View__Jsx3.make, {
                  flexDirection: "column",
                  flexBasis: {
                    NAME: "percent",
                    VAL: 100
                  },
                  children: Caml_option.some(React.createElement(Text__Jsx3.make, {
                            fontSize: {
                              NAME: "px",
                              VAL: 14
                            },
                            fontWeight: "bold",
                            lineClamp: 1,
                            children: people.length !== 1 ? Js_array.joinWith(", ", Belt_Array.map(people, (function (param) {
                                          return param.shortLabel;
                                        }))) : people[0].longLabel
                          }))
                }));
}

var ParticipantsBanner = {
  make: Conversations__Components$ParticipantsBanner
};

function Conversations__Components$ConversationCard$RentalPropertyDetails(props) {
  var rentalProperty = props.rentalProperty;
  var match = rentalProperty.status.listingStatus;
  if (typeof match === "number" && match >= 4) {
    return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
                icon: {
                  NAME: "icon",
                  VAL: /* Home */39
                },
                removed: true,
                children: React.createElement(ConversationCard__Jsx3.DetailsSecondLine.make, {
                      value: "Rental property has been removed"
                    })
              });
  }
  return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
              icon: Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(rentalProperty.images, 0), (function (param) {
                          return {
                                  NAME: "image",
                                  VAL: Utils__AttachmentUrl.makeAttachmentUrl(100, 100, true, true, undefined, undefined, param.key)
                                };
                        })), {
                    NAME: "icon",
                    VAL: /* Home */39
                  }),
              children: null
            }, React.createElement(ConversationCard__Jsx3.DetailsFirstLine.make, {
                  value: Property.DisplayLocation.toString(rentalProperty.location)
                }), React.createElement(ConversationCard__Jsx3.DetailsSecondLine.make, {
                  value: Property.Address.toString(rentalProperty.address) + " (Rental)"
                }));
}

var RentalPropertyDetails = {
  make: Conversations__Components$ConversationCard$RentalPropertyDetails
};

function Conversations__Components$ConversationCard$RentalNeedDetails(props) {
  var rentalNeed = props.rentalNeed;
  var match = rentalNeed.status.status;
  if (typeof match === "number" && match >= 4) {
    return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
                icon: {
                  NAME: "icon",
                  VAL: /* People */56
                },
                removed: true,
                children: React.createElement(ConversationCard__Jsx3.DetailsSecondLine.make, {
                      value: "Rental need has been removed"
                    })
              });
  }
  return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
              icon: {
                NAME: "icon",
                VAL: /* People */56
              },
              children: null
            }, React.createElement(ConversationCard__Jsx3.DetailsFirstLine.make, {
                  value: rentalNeed.headline
                }), React.createElement(ConversationCard__Jsx3.DetailsPrice.make, {
                  value: TMPUIKIT___Price__Jsx3.formatPrice(rentalNeed.priceRange)
                }));
}

var RentalNeedDetails = {
  make: Conversations__Components$ConversationCard$RentalNeedDetails
};

function Conversations__Components$ConversationCard$PropertyDetails(props) {
  var property = props.property;
  var match = property.status.listingStatus;
  if (match === 3) {
    return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
                icon: {
                  NAME: "icon",
                  VAL: /* Home */39
                },
                removed: true,
                children: React.createElement(ConversationCard__Jsx3.DetailsSecondLine.make, {
                      value: "Property has been removed"
                    })
              });
  } else {
    return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
                icon: Belt_Option.mapWithDefault(Belt_Option.map(Belt_Array.get(property.images, 0), (function (param) {
                            return Utils__AttachmentUrl.makeAttachmentUrl(324, 324, false, true, undefined, undefined, param.key);
                          })), {
                      NAME: "icon",
                      VAL: /* Home */39
                    }, (function (v) {
                        return {
                                NAME: "image",
                                VAL: v
                              };
                      })),
                children: null
              }, React.createElement(ConversationCard__Jsx3.DetailsFirstLine.make, {
                    value: Property.DisplayLocation.toString(property.location)
                  }), React.createElement(ConversationCard__Jsx3.DetailsSecondLine.make, {
                    value: Property.Address.toString(property.address)
                  }));
  }
}

var PropertyDetails = {
  make: Conversations__Components$ConversationCard$PropertyDetails
};

function Conversations__Components$ConversationCard$BuyerNeedDetails(props) {
  var buyerNeed = props.buyerNeed;
  var match = buyerNeed.status.status;
  if (match === 4) {
    return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
                icon: {
                  NAME: "icon",
                  VAL: /* People */56
                },
                removed: true,
                children: React.createElement(ConversationCard__Jsx3.DetailsSecondLine.make, {
                      value: "Buyer need has been removed"
                    })
              });
  }
  var match$1 = buyerNeed.headline;
  return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
              icon: {
                NAME: "icon",
                VAL: /* People */56
              },
              children: null
            }, typeof match$1 === "object" ? React.createElement(ConversationCard__Jsx3.DetailsFirstLine.make, {
                    value: match$1.VAL
                  }) : null, React.createElement(ConversationCard__Jsx3.DetailsPrice.make, {
                  value: TMPUIKIT___Price__Jsx3.formatPrice(buyerNeed.priceRange)
                }));
}

var BuyerNeedDetails = {
  make: Conversations__Components$ConversationCard$BuyerNeedDetails
};

function Conversations__Components$ConversationCard$BroadcastMessageDetails(props) {
  var broadcastMessage = props.broadcastMessage;
  var match = broadcastMessage.status;
  if (match === "DELETED") {
    return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
                icon: {
                  NAME: "icon",
                  VAL: /* Chat */20
                },
                removed: true,
                children: React.createElement(ConversationCard__Jsx3.DetailsSecondLine.make, {
                      value: "Broadcast Message has been removed",
                      lineClamp: 2
                    })
              });
  } else {
    return React.createElement(ConversationCard__Jsx3.DetailsWrapper.make, {
                icon: {
                  NAME: "icon",
                  VAL: /* Chat */20
                },
                children: null
              }, React.createElement(ConversationCard__Jsx3.DetailsFirstLine.make, {
                    value: broadcastMessage.category.name
                  }), React.createElement(ConversationCard__Jsx3.DetailsSecondLine.make, {
                    value: broadcastMessage.subject
                  }));
  }
}

var BroadcastMessageDetails = {
  make: Conversations__Components$ConversationCard$BroadcastMessageDetails
};

function formatRelativeToNow(date) {
  var days = DateFns.differenceInCalendarDays(date, $$Date.now(undefined));
  return Js_string.replace(" ", Utils.$$String.nbsp, days !== 0 ? (
                days !== 1 ? (
                    days < 365 ? DateFns.format(date, "eee M/d") : DateFns.format(date, "M/d/yyyy")
                  ) : "Yesterday"
              ) : DateFns.format(date, "h:mm aa"));
}

function Conversations__Components$ConversationCard(props) {
  var selected = props.selected;
  var conversation = props.conversation;
  var currentUser = props.currentUser;
  var selected$1 = selected !== undefined ? selected : false;
  var messageStatusEnabled = FeaturesV3.useFeatureFlipper("ConversationMessageStatus") === "on";
  var details = ReactRender.fromOption(conversation.context, (function (context) {
          switch (context.TAG | 0) {
            case /* PublicPropertySummary */0 :
            case /* PrivatePropertySummary */1 :
                return React.createElement(Conversations__Components$ConversationCard$PropertyDetails, {
                            property: context._0
                          });
            case /* PublicBuyerNeedSummary */2 :
            case /* PrivateBuyerNeedSummary */3 :
                return React.createElement(Conversations__Components$ConversationCard$BuyerNeedDetails, {
                            buyerNeed: context._0
                          });
            case /* RentalPropertySummary */4 :
                return React.createElement(Conversations__Components$ConversationCard$RentalPropertyDetails, {
                            rentalProperty: context._0
                          });
            case /* RentalNeedSummary */5 :
                return React.createElement(Conversations__Components$ConversationCard$RentalNeedDetails, {
                            rentalNeed: context._0
                          });
            case /* BroadcastMessageSummary */6 :
                return React.createElement(Conversations__Components$ConversationCard$BroadcastMessageDetails, {
                            broadcastMessage: context._0
                          });
            
          }
        }));
  var people = getPeople(currentUser.id, conversation.participants);
  var match = Conversations__Types.Message.senderIsUser(conversation.latestMessage, currentUser.id);
  var match$1 = conversation.latestMessage;
  var tmp;
  if (match) {
    var is = match$1.images;
    var fs = match$1.files;
    tmp = fs !== undefined ? "Sent " + (String(NonEmptyList.toArray(fs).length) + " files") : (
        is !== undefined ? "Sent " + (String(NonEmptyList.toArray(is).length) + " images") : "You: " + Belt_Option.getWithDefault(match$1.text, "")
      );
  } else {
    var is$1 = match$1.images;
    var fs$1 = match$1.files;
    tmp = fs$1 !== undefined ? "Received " + (String(NonEmptyList.toArray(fs$1).length) + " files") : (
        is$1 !== undefined ? "Received " + (String(NonEmptyList.toArray(is$1).length) + " images") : Belt_Option.getWithDefault(match$1.text, "")
      );
  }
  return React.createElement(ConversationCard__Jsx3.make, {
              people: people,
              timestamp: formatRelativeToNow(UTCDate.toUnzonedDate(conversation.latestMessage.sentAt)),
              unreadCount: messageStatusEnabled ? Conversations__Types.Conversation.countUnread(currentUser.id, conversation.messages) : 0,
              summary: tmp,
              selected: selected$1,
              children: details
            });
}

var ConversationCard = {
  RentalPropertyDetails: RentalPropertyDetails,
  RentalNeedDetails: RentalNeedDetails,
  PropertyDetails: PropertyDetails,
  BuyerNeedDetails: BuyerNeedDetails,
  BroadcastMessageDetails: BroadcastMessageDetails,
  formatRelativeToNow: formatRelativeToNow,
  make: Conversations__Components$ConversationCard
};

function Conversations__Components$MobileHeader(props) {
  var onBack = props.onBack;
  var people = getPeople(props.currentUser.id, props.participants);
  var tmp;
  if (people.length !== 1) {
    tmp = React.createElement(Avatar__Jsx3.Group.make, {
          children: Belt_Array.map(Belt_Array.slice(people, 0, 2), (function (param) {
                  var avatarURL = param.avatarURL;
                  var longLabel = param.longLabel;
                  return JsxPPXReactSupport.createElementWithKey(avatarURL + longLabel, Avatar__Jsx3.make, {
                              src: avatarURL,
                              name: longLabel
                            });
                })),
          size: "tiny"
        });
  } else {
    var match = people[0];
    tmp = React.createElement(Avatar__Jsx3.make, {
          src: match.avatarURL,
          name: match.longLabel,
          size: "tiny"
        });
  }
  return React.createElement(View__Jsx3.make, {
              mt: {
                NAME: "px",
                VAL: -20
              },
              pt: {
                NAME: "px",
                VAL: 10
              },
              pr: {
                NAME: "px",
                VAL: 5
              },
              pb: {
                NAME: "px",
                VAL: 10
              },
              pl: {
                NAME: "px",
                VAL: 5
              },
              alignItems: "center",
              flexDirection: "row",
              flexGrow: 0,
              position: "relative",
              borderStyle: "solid",
              borderWidth: "0 0 1px 0",
              borderColor: Colors.alto,
              backgroundColor: Theme__Color.wildSand,
              children: Caml_option.some(null)
            }, React.createElement(Touchable__Jsx3.make, {
                  style: {
                    hd: Css.alignContent("center"),
                    tl: {
                      hd: Css.opacity(0.6),
                      tl: {
                        hd: Css.borderRadius({
                              NAME: "px",
                              VAL: 4
                            }),
                        tl: {
                          hd: Css.marginRight({
                                NAME: "px",
                                VAL: 5
                              }),
                          tl: {
                            hd: Css.active({
                                  hd: Css.opacity(1),
                                  tl: /* [] */0
                                }),
                            tl: {
                              hd: Css.focus({
                                    hd: Css.outlineStyle("none"),
                                    tl: {
                                      hd: Css.backgroundColor(Css.rgba(0, 0, 0, {
                                                NAME: "num",
                                                VAL: 0.1
                                              })),
                                      tl: /* [] */0
                                    }
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  },
                  p: {
                    NAME: "px",
                    VAL: 10
                  },
                  onPress: (function (param) {
                      Curry._1(onBack, undefined);
                    }),
                  children: React.createElement(Icon__Jsx3.make, {
                        icon: /* ArrowLeft */6
                      })
                }), tmp, React.createElement(View__Jsx3.make, {
                  ml: {
                    NAME: "px",
                    VAL: 10
                  },
                  flexDirection: "column",
                  flexBasis: {
                    NAME: "percent",
                    VAL: 100
                  },
                  children: Caml_option.some(React.createElement(Text__Jsx3.make, {
                            fontSize: {
                              NAME: "px",
                              VAL: 14
                            },
                            fontWeight: "bold",
                            lineClamp: 1,
                            children: people.length !== 1 ? Js_array.joinWith(", ", Belt_Array.map(people, (function (param) {
                                          return param.shortLabel;
                                        }))) : people[0].longLabel
                          }))
                }));
}

var MobileHeader = {
  Touchable: undefined,
  make: Conversations__Components$MobileHeader
};

function Conversations__Components$PublicVisibilityNotice(props) {
  return React.createElement(View__Jsx3.make, {
              p: {
                NAME: "px",
                VAL: 15
              },
              backgroundColor: Theme__Color.white,
              children: Caml_option.some(React.createElement(HighlightSection__Jsx3.make, {
                        children: "This conversation is public."
                      }))
            });
}

var PublicVisibilityNotice = {
  make: Conversations__Components$PublicVisibilityNotice
};

function useShouldDisplay(conversation) {
  var featureEnabled = FeaturesV3.useFeatureFlipper("SetConversationAnonymousStatus") === "on";
  var match = conversation.context;
  var ownerAccount;
  if (match !== undefined && match.TAG === /* PrivateProperty */1) {
    var agent = match._0.property.agent;
    ownerAccount = agent ? agent._0 : undefined;
  } else {
    ownerAccount = undefined;
  }
  var userIsPropertyOwner = CurrentUser.sameAccountAsCurrentUser(ownerAccount, undefined);
  if (featureEnabled && conversation.anonymous) {
    return userIsPropertyOwner;
  } else {
    return false;
  }
}

function Conversations__Components$AnonymousControlSection(props) {
  var conversation = props.conversation;
  var match = React.useState(function () {
        return false;
      });
  var setShowConfirmation = match[1];
  var shouldDisplay = useShouldDisplay(conversation);
  var match$1 = Conversations__GraphQL.SetConversationAnonymousStatusMutation.use(undefined);
  var mutate = match$1[0];
  var openDialog = function (param) {
    Curry._1(setShowConfirmation, (function (param) {
            return true;
          }));
  };
  var closeDialog = function (param) {
    Curry._1(setShowConfirmation, (function (param) {
            return false;
          }));
  };
  var match$2 = SystemMessages.useSystemMessages(undefined);
  var addMessage = match$2.addMessage;
  var handleShareIdentity = function (param) {
    Curry._1(setShowConfirmation, (function (param) {
            return false;
          }));
    $$Promise.get(Curry._2(mutate, conversation.id, false), (function (x) {
            if (x.TAG === /* Ok */0) {
              return ;
            } else {
              return Curry._1(addMessage, SystemMessages.Message.make(undefined, "error", "There was a problem sharing your information", 5000, undefined, undefined, undefined));
            }
          }));
  };
  if (shouldDisplay) {
    return React.createElement(React.Fragment, undefined, React.createElement(Dialog__Jsx3.make, {
                    title: "Share information?",
                    isOpen: match[0],
                    ariaLabel: "Are you sure?",
                    onDismiss: closeDialog,
                    children: React.createElement(ViewStack.make, {
                          alignItems: "center",
                          flexDirection: "column",
                          children: Caml_option.some(null)
                        }, React.createElement(View__Jsx3.make, {
                              children: "This action cannot be undone."
                            }), React.createElement(ViewStack.make, {
                              justifyContent: "center",
                              flexDirection: "row",
                              children: Caml_option.some(null)
                            }, React.createElement(Buttons__Jsx3.SecondaryButton.make, {
                                  onClick: closeDialog,
                                  children: "Cancel"
                                }), React.createElement(Buttons__Jsx3.DangerButton.make, {
                                  onClick: handleShareIdentity,
                                  children: "Yes, share my identity"
                                })))
                  }), React.createElement(View__Jsx3.make, {
                    p: {
                      NAME: "px",
                      VAL: 15
                    },
                    children: Caml_option.some(React.createElement(HighlightSection__Jsx3.make, {
                              children: Caml_option.some(React.createElement(ViewStack.make, {
                                        alignItems: "center",
                                        flexDirection: "column",
                                        children: Caml_option.some(null)
                                      }, React.createElement(View__Jsx3.make, {
                                            children: "You are anonymous to other users in this conversation."
                                          }), React.createElement(View__Jsx3.make, {
                                            children: Caml_option.some(React.createElement(Buttons__Jsx3.PrimaryButton.make, {
                                                      onClick: openDialog,
                                                      children: "Share my identity"
                                                    }))
                                          })))
                            }))
                  }));
  } else {
    return null;
  }
}

var AnonymousControlSection = {
  useShouldDisplay: useShouldDisplay,
  make: Conversations__Components$AnonymousControlSection
};

function Conversations__Components$DeactivatedConversationWarning(props) {
  var deactivatedUser = Belt_List.get(Belt_List.keepMap(props.participants, (function (x) {
              if (!x) {
                return ;
              }
              var user = x._0;
              if (user.membershipStatus === "TERMINATED") {
                return user;
              }
              
            })), 0);
  var deactivatedUserName = Belt_Option.mapWithDefault(deactivatedUser, "your recipient", Types__User.label);
  return React.createElement(WarningSection__Jsx3.make, {
              children: "You can't reply as " + (deactivatedUserName + " no longer has an active subscription on TAN")
            });
}

var DeactivatedConversationWarning = {
  make: Conversations__Components$DeactivatedConversationWarning
};

var View;

var Form;

var Buttons;

var Avatar;

var ContextCard;

exports.View = View;
exports.Form = Form;
exports.Buttons = Buttons;
exports.Avatar = Avatar;
exports.getPeople = getPeople;
exports.ParticipantsBanner = ParticipantsBanner;
exports.ContextCard = ContextCard;
exports.ConversationCard = ConversationCard;
exports.MobileHeader = MobileHeader;
exports.PublicVisibilityNotice = PublicVisibilityNotice;
exports.AnonymousControlSection = AnonymousControlSection;
exports.DeactivatedConversationWarning = DeactivatedConversationWarning;
/* Css Not a pure module */
